import React from "react";

import Box from "@mui/material/Box";
import styled from "@mui/material/styles/styled";
import MuiTableCell from "@mui/material/TableCell";
import Typography, { TypographyProps } from "@mui/material/Typography";

import MetricWithIndicator from "@app/analytics/components/MetricWithIndicator";
import VideoIconButton, {
  VideoIconButtonProps,
} from "@app/analytics/components/VideoIconButton";

import Stack, { Row, StackProps } from "@rui/Stack";
import TooltipIcon from "@rui/TooltipIcon";

export const Card = styled(
  ({ open: _, ...props }: StackProps & { open: boolean }) => (
    <Stack {...props} />
  )
)(({ theme, open, onClick }) => ({
  cursor: onClick ? "pointer" : "default",
  border: `${open ? 2 : 1}px solid`,
  borderColor: open
    ? theme.palette.shades.secondary[500]
    : theme.palette.shades.neutral[100],
  padding: open ? "11px" : "12px", // reduce padding slightly to make up for larger border when open
  borderRadius: "6px",
  width: "100%",
  backgroundColor: "white",
}));

export const Name = styled((props: TypographyProps) => (
  <Typography variant="bodyPrimaryMed" noWrap {...props} />
))(({ theme }) => ({
  color: theme.palette.shades.neutral[700],
  lineHeight: "20px",
  paddingRight: theme.spacing(1),
}));

export const CollapseContentWrapper = styled(Box)(({ theme }) => ({
  borderRadius: "8px",
  backgroundColor: theme.palette.shades.ghost[300],
  padding: "8px",
  marginTop: theme.spacing(1),
}));

export const TableCell = styled(MuiTableCell)(({ theme }) => ({
  borderBottom: "none",
  borderRight: `1px solid ${theme.palette.shades.neutral[100]}`,
  padding: "0px 12px 4px 12px",
  "&:first-of-type": {
    borderLeft: "none",
    paddingLeft: "0px",
  },
  "&:last-of-type": {
    paddingRight: "0px",
    borderRight: "none",
  },
  width: "33.33%",
}));

export const ScoreTableCell = ({
  children,
  score,
  tooltip,
}: {
  children: React.ReactNode;
  score: number | null;
  tooltip?: string;
}) => {
  return (
    <TableCell>
      <Row variant="apart" spacing={1}>
        <Row alignItems="center" spacing={0.5}>
          {children}
          {tooltip && <TooltipIcon title={tooltip} />}
        </Row>
        <MetricWithIndicator
          labelSx={{
            color: "shades.neutral.600",
            fontWeight: 500,
            minWidth: score ? "18px" : undefined,
          }}
          value={score}
        />
      </Row>
    </TableCell>
  );
};

export const PlayButton = styled(
  ({ playing, ...props }: VideoIconButtonProps & { playing: boolean }) => (
    <VideoIconButton
      icon={playing ? "pause" : "play"}
      tooltip={playing ? "Pause" : "Play"}
      onClick={() => {}}
      {...props}
    />
  )
)({});

export const NameRow = styled(Row)(({ theme }) => ({
  padding: theme.spacing(0, 0.5),
  borderRadius: "4px",
  ".participant-name__assign": {
    display: "none",
    color: theme.palette.shades.neutral[400],
    svg: {
      fontSize: "12px",
      marginRight: theme.spacing(0.5),
    },
  },
}));
